import React from "react";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Team from "./components/Team";
import Courses from "./components/Courses";
import WhyUs from "./components/WhyUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Terms from "./components/Terms";
import "./styles/master.css"; // Master stylesheet

const Home = () => (
  <>
    <Hero />
    <div className="main-content">
      <About />
      <Team />
      <Courses />
      <WhyUs />
      <Contact />
      </div>
    <Terms /> {/* Moved PopupWindow outside of main-content */}
  </>
);

const App = () => {
  return (
    <>
      <Navbar />
      <div style={{ position: 'relative', top: '60px' }}> {/* Adjust top value to match navbar height */}
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
      <Footer />
    </>
  );
};

export default App;
